module.exports = __webpack_public_path__ + "img/itx-file-type-eml.5f1237f0.svg";